module.exports = __webpack_public_path__ + "img/btn_more@3x.c9822dce.png";